import { Card, CardBody, Center, Link, Text } from "@chakra-ui/react";
import { Link as RouterLink, Outlet } from "react-router-dom";

import { useAuth } from "../context";
import { CollecticonCircleXmark } from "@devseed-ui/collecticons-chakra";

function ProtectedRoute() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Outlet />;
  }

  return (
    <Center>
      <Card p="4" w="50ch">
        <CardBody textAlign="center">
          <CollecticonCircleXmark size="8" mb="4" />
          <Text>This page is restricted to authorized users.<br /> Please <Link as={RouterLink} to="/login">sign in</Link></Text>
        </CardBody>
      </Card>
    </Center>
  );
}

export default ProtectedRoute;
